import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type QuizPathProgressSnapshot = {
  current: number;
  total: number;
};

type QuizPathProgressState = {
  byCourseId: Record<string, QuizPathProgressSnapshot>;
};

const initialState: QuizPathProgressState = {
  byCourseId: {},
};

const quizPathProgressSlice = createSlice({
  name: "quizPathProgress",
  initialState,
  reducers: {
    commitQuizPathProgress: (
      state,
      action: PayloadAction<{ courseId: string } & QuizPathProgressSnapshot>,
    ) => {
      const { courseId, current, total } = action.payload;
      state.byCourseId[courseId] = { current, total };
    },
    resetQuizPathProgress: (state) => {
      state.byCourseId = {};
    },
  },
});

export const { commitQuizPathProgress, resetQuizPathProgress } =
  quizPathProgressSlice.actions;
export default quizPathProgressSlice.reducer;
